<template>
  <div class="mobile-partners-card">
    <img src="/images/promo/connect-features/mobile-partners-card.svg" alt="Partners card" />
  </div>
</template>

<script>
export default {};
</script>
